import { THttpError } from './types'

/**
 * @deprecated - should not be a hook, user `getHttpError` instead
 */
export const useHttpError = (
  HttpErrors: THttpError,
): ((status: number | undefined) => string | undefined) => {
  return (status) => (status ? HttpErrors[status] : HttpErrors[400])
}
